import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './fahrzeugtyp.list-view.html',
  styleUrls: ['./fahrzeugtyp.list-view.scss'],
})
export class FahrzeugtypListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
